import { Container, Typography, Box, Divider } from "@mui/material";
import NextBreadcrumbs from "../component/NextBreadcrumbs";
import Page from "../component/Page";

export default function PublicHealth() {
  return (
    <Page>
      <img src="./background/public_health.jpg" style={{ width: "100%", maxHeight: 250, objectFit: "cover", objectPosition: "center 80%" }}></img>
      <Container sx={{ py: 5 }}>
        <NextBreadcrumbs></NextBreadcrumbs>
        <Box>
          <Typography variant="h3">Public Health</Typography>
          <Typography variant="body1" sx={{ textAlign: "justify", py: 3 }}>Weather impacts our health directly (extreme heat and cold, severe storms) and indirectly (allergies, mental health).  Kentucky’s mid-latitude location makes it prone to summer and winter temperature extremes and large swings in weather conditions. The geography of the Ohio Valley also makes it susceptible to hot, stagnant air conditions during the summer, and which is a contributing factor for some urban counties exceeding EPA air pollution standards. High air pollution can aggravate asthma and lead to higher mortality rates among the most vulnerable.  Kentucky is also known for its allergens, in part to its beautiful bluegrass.  The Kentucky Mesonet’s real-time monitoring of weather and climate can help identify conditions when negative health outcomes are most likely, and thereby, help communities take proactive actions to prevent and mitigate these impacts.
          </Typography>
          {/* <Box sx={{
            position: "relative", height: 600,
            width: "100%",
            overflow: "hidden"
          }}>
            <iframe src="https://airquality.weather.gov/sectors/conus.php" style={{
              position: "absolute",
              top: -250,
              left: -10,
              width: "110%",
              height: "200vh",
            }}></iframe>
          </Box> */}

          <iframe src="https://airquality.weather.gov/sectors/conus.php" style={{
            width: "100%",
            height: 600,
            border: 0
          }}></iframe>
          <Divider sx={{ my: 5 }}></Divider>
          <img src="https://www.cpc.ncep.noaa.gov/products/stratosphere/uv_index/gif_files/uvi_map.png" style={{ width: "100%" }}></img>
        </Box>
      </Container>
    </Page >
  );
}
